import { inject } from '@angular/core';

import { injectMutation } from '@tanstack/angular-query-experimental';

import { firstValueFrom } from 'rxjs';

import { Role } from 'src/app/admin/models';
import { RoleApiService } from '../services/role-api.service';

/**
 * Create or edit a role - `role.id` picks between POST /role/:id and PUT /role.
 *
 * No query invalidation: the roles list is a server-side ag-grid, not a query.
 */
export function injectSaveRoleMutation() {
  const roleApi = inject(RoleApiService);

  return injectMutation(() => ({
    mutationFn: (role: Role) =>
      firstValueFrom(
        role.id ? roleApi.saveRole(role) : roleApi.createRole(role),
      ),
  }));
}

/**
 * Delete a role (DELETE /role/:id). No toast and no invalidation - deletion stays
 * silent until the roles list is reloaded.
 */
export function injectDeleteRoleMutation() {
  const roleApi = inject(RoleApiService);

  return injectMutation(() => ({
    mutationFn: (roleId: string) => firstValueFrom(roleApi.deleteRole(roleId)),
  }));
}
